import Angular from "angular";

let TextareaAutoHeightModule = Angular.module('textarea-autoheight', []);

TextareaAutoHeightModule.directive('textareaAutoheight', function () {

    function countLines(str) {
        try {
            return ((str.match(/[^\n]*\n[^\n]*/gi).length));
        } catch (e) {
            return 0;
        }
    }

    return {
        restrict: 'A',
        require: 'ngModel',

        link: function (scope, element, attrs, ngModel) {
            ngModel.$formatters.push(function (value) {
                if (value) {
                    element.attr('rows', countLines(value) + 2);
                }

                return value;
            });


            ngModel.$parsers.push(function (value) {
                if (value) {
                    element.attr('rows', countLines(value) + 2);
                }

                return value;
            });
        }
    }
});

export default TextareaAutoHeightModule;



// WEBPACK FOOTER //
// ./src/modules/core/directives/textarea-autoheight.js